import { IEvidenceUploadStatus } from '@aca-new/app/pages/payments/shared/models/interfaces/evidence-upload-status.interface';

/**
 * Stops the transfer submission when any slip failed to upload.
 * @param {IEvidenceUploadStatus[]} results - Upload results of every selected slip.
 * @returns {IEvidenceUploadStatus[]} The same results when all uploads succeeded.
 */
export function throwIfEvidenceUploadFailed(results: IEvidenceUploadStatus[]): IEvidenceUploadStatus[] {
  if (results.some((result: IEvidenceUploadStatus): boolean => result.code === 'error')) {
    throw new Error('Transfer slip upload failed');
  }

  return results;
}
